/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {ProtobufFieldMask} from './ProtobufFieldMask';
import {ServiceLocale} from './ServiceLocale';

/**
 * The ServiceUpdateLocaleRequest model module.
 * @module model/ServiceUpdateLocaleRequest
 * @version version not set
 */
export class ServiceUpdateLocaleRequest {
  /**
   * Constructs a new <code>ServiceUpdateLocaleRequest</code>.
   * @alias module:model/ServiceUpdateLocaleRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdateLocaleRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdateLocaleRequest} obj Optional instance to populate.
   * @return {module:model/ServiceUpdateLocaleRequest} The populated <code>ServiceUpdateLocaleRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdateLocaleRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('locale'))
        obj.locale = ServiceLocale.constructFromObject(data['locale']);
      if (data.hasOwnProperty('update_mask'))
        obj.updateMask = ProtobufFieldMask.constructFromObject(data['update_mask']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
ServiceUpdateLocaleRequest.prototype.id = undefined;

/**
 * @member {module:model/ServiceLocale} locale
 */
ServiceUpdateLocaleRequest.prototype.locale = undefined;

/**
 * @member {module:model/ProtobufFieldMask} updateMask
 */
ServiceUpdateLocaleRequest.prototype.updateMask = undefined;


